function GenderTagForNewCustomers() {
  let genderTag = document.getElementById('gender_tag');
  let genderRadios = document.querySelectorAll('.gender-choice-radio');

  if (genderTag) {
    genderRadios.forEach((element) => {
      element.addEventListener('change', function() {
        console.log('Gender: ', element.value);
        if (element.checked) {
          genderTag.value = element.value;
        }
      });
    });
  }
}
export default GenderTagForNewCustomers;
